import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { getNowAsUtc } from 'helpers/datetime';
import Button from 'components/Form/Button';
import { DATE_RANGE_PRESETS } from '../../constants';
import messages from '../../messages';
const RangePresets = ({ startDate, endDate, minDate, maxDate, newResultsStartDate, styleModifier = 'quinary', isInProgress = false, onChange })=>{
    const endOfDay = getNowAsUtc().endOf('day');
    const onClickAll = (evt)=>{
        evt.stopPropagation();
        onChange(minDate, maxDate);
    };
    const onClickNew = (evt)=>{
        evt.stopPropagation();
        onChange(newResultsStartDate, endOfDay);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            DATE_RANGE_PRESETS.map(({ number, unit })=>{
                const baseStartDate = maxDate && maxDate.clone().subtract(number, unit).add(1, 'day');
                const presetStartDate = minDate && (baseStartDate.isAfter(minDate) ? baseStartDate : minDate).clone().startOf('day');
                const onClick = (evt)=>{
                    evt.stopPropagation();
                    onChange(presetStartDate, maxDate);
                };
                return /*#__PURE__*/ _jsx(Button, {
                    styleModifier: styleModifier,
                    className: cn('btn--filled', {
                        'text--primary': startDate && endDate && presetStartDate.isSame(startDate, 'day') && maxDate.isSame(endDate, 'day')
                    }),
                    labelMessage: messages.presets[unit],
                    labelMessageValues: {
                        number
                    },
                    isDisabled: isInProgress,
                    onClick: onClick
                }, `${unit}${number}`);
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: styleModifier,
                labelMessage: messages.presets.all,
                className: cn('btn--filled', {
                    'text--primary': startDate && endDate && minDate.isSame(startDate, 'day') && maxDate.isSame(endDate, 'day')
                }),
                isDisabled: isInProgress,
                onClick: onClickAll
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: styleModifier,
                labelMessage: messages.presets.newResults,
                className: cn('btn--filled', {
                    'text--primary': startDate && endDate && newResultsStartDate.isSame(startDate, 'day') && endOfDay.isSame(endDate, 'day')
                }),
                isDisabled: isInProgress,
                onClick: onClickNew
            })
        ]
    });
};
export default RangePresets;
